<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title" style="max-width:860px;">
        {{
          'Opening in ' +
          project.name +
          ' - ' +
          selectedBuilding.name +
          ' - ' +
          selectedFloor.name +
          ' - ' +
          selectedZone.name
        }}
      </p>
      <div class="buttons has-addons is-right">
        <button
          class="button"
          v-if="admin && newOpening == false"
          @click="
            editMode = true
            $store.dispatch('getBearerToken')
          "
        >
          Edit
        </button>
      </div>
    </header>
    <section class="modal-card-body">
      <b-message type="is-info" has-icon v-if="newOpening == true">
        Uw bent op dit moment in het scherm waar u een nieuwe opening kunt aanmaken. Vul de gegevens in en sla de
        opening op. Later kunt uw de foto's en doorvoeren hierbij toevoegen.
      </b-message>
      <b-message type="is-info" has-icon v-if="newOpening == false && admin == true">
        Druk op 'Edit' om de opening te bewerken of fotos en doorvoeringen toe te voegen.
      </b-message>
      <!-- <div class="card" style="padding:30px;width:100%"> -->
      <div class="flex-container" v-if="openingData">
        <div style="margin-right: 20px; width: 100%">
          <opening-info :openingData="openingData" :editMode="editMode" :admin="admin" @changed="changed = true" />
          <div id="penetrant">
            <h2 class="is-size-5 has-text-primary modaltitle">Doorvoeren</h2>
            <table
              class="opening-table"
              style="width: 100%"
              v-if="openingData.penetrants.length > 0 || (editMode && newOpening == false)"
              id="penetrants"
            >
              <tr v-if="openingData.penetrants.length > 0">
                <th>Type</th>
                <th></th>
              </tr>
              <tbody>
                <tr
                  class="clickable-tablerow"
                  v-for="penetrant in openingData.penetrants"
                  :key="penetrant.$id"
                  :class="{
                    isSelectedPhotoRow: penetrant == openingData.penetrants[selectedPenetrant]
                  }"
                  @click="setSelectedPenetrant(penetrant)"
                >
                  <td>
                    <div style="width: 100px">{{ penetrant.type }}</div>
                  </td>
                  <td @click="deletePenetrant(penetrant)" v-if="editMode" style="float: right">
                    <b-button class="miniButton" type="is-danger is-small" icon-right="delete is-small"></b-button>
                  </td>
                </tr>
                <tr v-if="editMode">
                  <td colspan="2">
                    <b-dropdown position="is-top-left" v-model="listChoise" aria-role="list" @input="addPenetrant">
                      <a slot="trigger" role="button"
                        ><span>Klik hier om een nieuwe opening toe te voegen </span
                        ><b-icon style="vertical-align: middle" icon="menu-down"></b-icon
                      ></a>
                      <b-dropdown-item v-for="option in list" :value="option" :key="option.id" aria-role="listitem">
                        <div class="media">
                          <div class="media-content">
                            <!-- <h3>Public</h3> -->
                            {{ option }}
                          </div>
                        </div>
                      </b-dropdown-item>
                    </b-dropdown>
                  </td>
                </tr>
              </tbody>
            </table>

            <p v-else>Geen doorvoeren</p>
          </div>

          <div id="photo">
            <h2 class="is-size-5 has-text-primary modaltitle">Mutatie History</h2>
            <table
              class="opening-table"
              style="width: 100%"
              v-if="openingData.photos.length > 0 || (editMode && newOpening == false)"
            >
              <tr v-if="openingData.photos.length > 0">
                <!-- <th>#</th> -->
                <th>Datum</th>
                <th>Status</th>
                <th></th>
              </tr>
              <tr
                class="clickable-tablerow"
                v-for="(photo, index) in openingData.photos"
                :key="index"
                :class="{ isSelectedPhotoRow: photo == selectedPhoto }"
                @click="setSelectedPhoto(photo)"
              >
                <!-- <td>{{ index }}</td> -->
                <td>{{ new Date(photo.captureTime).toLocaleDateString('nl-NL') }}</td>
                <td>{{ photo.registrationType | status }}</td>
                <td @click="deletePhoto(photo)" v-if="editMode">
                  <b-button class="miniButton" type="is-danger is-small" icon-right="delete is-small"></b-button>
                </td>
              </tr>
              <tr
                v-if="editMode"
                class="clickable-tablerow"
                @click="
                  addPhoto = true
                  selectedPhoto = {}
                "
              >
                <td>...</td>
                <td>Klik hier om een nieuwe foto te uploaden</td>
                <td></td>
              </tr>
            </table>

            <p v-else>Geen foto's</p>
          </div>
        </div>
        <div style="width: 100%">
          <div v-if="selectedPenetrant != null && selectedPenetrant >= 0">
            <add-penetrant
              :selectedPenetrant="openingData.penetrants[selectedPenetrant]"
              :editMode="editMode"
            ></add-penetrant>
            <opening-photo
              :selectedPhoto="selectedPhoto"
              :editMode="editMode"
              :addPhoto="addPhoto"
              @submit="photoSubmitted"
            ></opening-photo>
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot force-right" v-if="editMode">
      <div class="buttons">
        <button
          class="button"
          @click="
            refreshData()
            editMode = false
          "
        >
          Cancel
        </button>
        <button class="button is-primary" @click="saveOpening()">Save</button>
      </div>
    </footer>
  </div>
  <!-- </div> -->
</template>

<script>
import { mapGetters } from 'vuex'
import rmBtnMixin from '@/mixins/rmBtnMixin.js'
import cloneMixin from '@/mixins/cloneMixin.js'
import editable from '@/components/Projects/editable.vue'
import addPenetrant from '@/components/Projects/AddPenetrant.vue'
import openingPhoto from '@/components/Projects/OpeningPhoto.vue'
import openingInfo from '@/components/Projects/OpeningInfo.vue'
import openingService from '@/services/openingService.js'
import projectService from '@/services/projectService.js'

import _ from 'lodash'
import JQuery from 'jquery'
export default {
  filters: {
    prettyDate: function (value) {
      if (!value) return ''
      const d = new Date(value)
      return `${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`
    },
    // stripEmail: function (value) {
    //   if (!value) return ''
    //   if (!value.includes('@')) return value

    //   const i = value.indexOf('@')
    //   return value.substring(0, i)
    // },
    status: function (value) {
      if (!value) return ''
      let res = ''

      switch (value) {
        case 0:
          res = 'Geen'
          break
        case 1:
          res = 'Offerteopname: geen QR'
          break
        case 2:
          res = 'Vooropname: niet akkoord'
          break
        case 3:
          res = 'Vooropname: akkoord'
          break
        case 4:
          res = 'Montage: niet akkoord'
          break
        case 5:
          res = 'Montage: akkoord'
          break
        case 6:
          res = 'Inspectie: akkoord'
          break
        case 7:
          res = 'Inspectie: niet akkoord'
          break
        case 8:
          res = 'Inspectie periodiek: akkoord'
          break
        case 9:
          res = 'Mutatie: reparatie/herstel'
          break
        default:
          break
      }
      return res
    }
  },
  components: {
    editable,
    addPenetrant,
    openingPhoto,
    openingInfo
  },

  mixins: [rmBtnMixin, cloneMixin],
  props: {
    newOpening: {
      type: Boolean,
      default: false
    },
    admin: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      selectedPhoto: null,
      selectedPenetrant: null,
      editMode: false,
      openingData: { penetrants: [], photos: [] },
      newPenetrants: [],
      removedPenetrants: [],
      addPhoto: false,
      removedPhotos: [],
      newPhotos: [],
      changed: false,
      addPenetrantBool: false,

      newOpeningObject: {
        assemblyTime: 0,
        comment: '',
        dbDate: '',
        dbUser: '',
        fireRating: '',
        idOnDrawing: 0,
        openingId: null,
        penetrants: [],
        photos: [],
        room: '',
        zone: '',
        zoneId: '',
        wallFloorAssembly: ''
      },
      list: ['loos', 'lucht', 'elektra', 'buis / pijp', 'lineaire voeg', 'actie'],
      listChoise: 'Klik hier om een nieuwe opening toe te voegen'
    }
  },
  computed: {
    ...mapGetters([
      'selectedOpening',
      'selectedBuilding',
      'selectedFloor',
      'user',
      'selectedZone',
      'project',
      'user',
      'adminClaim'
    ]),
    backgroundImg() {
      return `backgroundImage: url(${this.selectedPhoto.uri})`
    }
  },
  watch: {
    selectedOpening: function (val) {
      console.log('selected opening changed')
    }
  },
  beforeMount() {
    if (this.newOpening == false) {
      this.cloneData()

      if (this.selectedOpening) {
        if (this.selectedOpening.photos.length > 0)
          this.selectedPhoto = this.selectedOpening.photos[this.selectedOpening.photos.length - 1]

        if (this.selectedOpening.penetrants.length > 0) this.selectedPenetrant = 0
      }
    } else {
      this.editMode = true
      this.openingData = this.newOpeningObject
      this.openingData.dbUser = this.user.email
      this.openingData.zone = this.selectedZone.name
      this.openingData.zoneId = this.selectedZone.zoneId
      const today = new Date(Date.now())
      this.openingData.dbDate = today.toJSON()
    }
  },

  methods: {
    refreshData() {
      if (this.newOpening == false) {
        this.selectedPhoto = null
        this.selectedPenetrant = -1
        if (this.selectedOpening.photos.length > 0) this.selectedOpening.photos[0]
        if (this.selectedOpening.penetrants.length > 0) this.selectedPenetrant = 0
        this.openingData = new Object()
        this.openingData = { penetrants: [], photos: [] }
        this.cloneData()
      } else {
        this.$parent.close()
      }
    },
    photoSubmitted(photoInfo) {
      this.newPhotos.push(photoInfo)
      this.openingData.photos.push(photoInfo)
      this.setSelectedPhoto(photoInfo)
      this.addPhoto = false
    },
    cloneData() {
      this.cloneDataOpening(this.selectedOpening, this.openingData, true)
    },
    cloneDataOpening(src, dest, includePenetrantsAndPhotos = false) {
      //
      dest.openingId = _.cloneDeep(src.openingId)
      dest.assemblyTime = _.cloneDeep(src.assemblyTime)
      dest.captureTime = _.cloneDeep(src.captureTime)
      dest.comment = _.cloneDeep(src.comment)
      dest.dbDate = _.cloneDeep(src.dbDate)
      dest.dbUser = _.cloneDeep(src.dbUser)
      dest.fireRating = _.cloneDeep(src.fireRating)
      dest.idOnDrawing = _.cloneDeep(src.idOnDrawing)
      dest.room = _.cloneDeep(src.room)
      dest.tagId = _.cloneDeep(src.tagId)
      dest.wallFloorAssembly = _.cloneDeep(src.wallFloorAssembly)
      dest.zoneId = _.cloneDeep(src.zoneId)
      // if include penetrant and photos
      if (includePenetrantsAndPhotos) {
        src.penetrants.forEach(p => this.cloneDataPenetrant(p, dest))
        src.photos.forEach(p => this.cloneDataPhoto(p, dest))
      }
    },
    cloneDataPenetrant(src, dest) {
      //
      const newPenetrant = new Object()
      newPenetrant.penetrantId = _.cloneDeep(src.penetrantId)
      newPenetrant.complexityFactor = _.cloneDeep(src.complexityFactor)
      newPenetrant.count = _.cloneDeep(src.count)
      newPenetrant.isolation = _.cloneDeep(src.isolation)
      newPenetrant.length = _.cloneDeep(src.length)
      newPenetrant.openingId = _.cloneDeep(src.openingId)
      newPenetrant.sizeCategory = _.cloneDeep(src.sizeCategory)
      newPenetrant.system = _.cloneDeep(src.system)
      newPenetrant.type = _.cloneDeep(src.type)
      dest.penetrants.push(newPenetrant)
    },
    cloneDataPhoto(src, dest) {
      const newPhoto = new Object()
      newPhoto.captureTime = _.cloneDeep(src.captureTime)
      newPhoto.captureUser = _.cloneDeep(src.captureUser)
      newPhoto.comment = _.cloneDeep(src.comment)
      newPhoto.openingId = _.cloneDeep(src.openingId)
      newPhoto.photoId = _.cloneDeep(src.photoId)
      newPhoto.registrationType = _.cloneDeep(src.registrationType)
      newPhoto.uri = _.cloneDeep(src.uri)
      dest.photos.push(newPhoto)
    },
    async saveOpening() {
      let res = new Object()

      if (this.newOpening == false) {
        //
        //delete knop met delete list of penetrants after save.
        if (this.removedPenetrants.size != 0) {
          this.removedPenetrants.forEach(async e => {
            await openingService.deletePenetrantOpening(this.project.projectId, this.selectedOpening.openingId, e)
          })
          this.removedPenetrants = []
        }

        // // update all pennetrants
        if (this.openingData.penetrants.length > 0) {
          this.openingData.penetrants.forEach(async e1 => {
            const res = this.selectedOpening.penetrants.filter(e2 => e2.penetrantId == e1.penetrantId)
            if (res.length != 0) {
              if (this.comparePenetrant(e1, res[0])) {
                //servercall edit penetrant
                console.log('change', e1)
                await openingService.editPenetrantOpening(
                  this.project.projectId,
                  this.openingData.openingId,
                  e1.penetrantId,
                  e1
                )
              }
            }
          })
        }
        if (this.newPenetrants.length > 0) {
          this.newPenetrants.forEach(
            async e =>
              await openingService.addPenetrantOpening(
                this.project.projectId,
                this.openingData.openingId,
                JSON.stringify(e)
              )
          )
          this.newPenetrants = []
        }

        if (this.newPhotos.length > 0) {
          this.newPhotos.forEach(async e => {
            const photoRes = await openingService.addPhotoOpening(this.project.projectId, this.openingData.openingId, e)
          })
          this.newPhotos = []
        }
        if (this.removedPhotos.size != 0) {
          this.removedPhotos.forEach(
            async e =>
              await openingService.deletePhotoOpening(this.project.projectId, this.selectedOpening.openingId, e)
          )
          this.removedPhotos = []
        }

        if (this.compare() == true) {
          console.log('update opening')
          const data = new Object()
          //delete data
          this.cloneDataOpening(this.openingData, data)
          res = await openingService.updateOpening(this.project.projectId, this.selectedOpening.openingId, data)
        }
        if (res.status == 200) {
          console.log('update succeed')
        }

        res = await projectService.getZone(this.project.projectId, this.selectedZone.zoneId)
        this.$store.commit('SET_SELECTED_ZONE', res.data)
        res = await openingService.getOpeningByTag(this.project.projectId, this.selectedOpening.tagId)
        this.$emit('created')
        this.$store.commit('SET_SELECTED_OPENING', res.data)
      } else {
        const dataObjectToServer = _.cloneDeep(this.openingData)
        delete dataObjectToServer['zone']
        delete dataObjectToServer['penetrants']
        delete dataObjectToServer['photos']
        dataObjectToServer.openingId = 0
        res = await openingService.addOpening(this.project.projectId, dataObjectToServer)
        this.openingData.openingId = res.data
      }

      if (res.status == 200) {
        this.$store.commit('SET_SELECTED_OPENING', this.openingData)
        //this.$parent.close()
        res = await projectService.getZone(this.project.projectId, this.selectedZone.zoneId)
        this.$store.commit('SET_SELECTED_ZONE', res.data)
        this.$emit('created', this.openingData)
      } else {
        console.error('something went wrong')
      }
      this.editMode = false
    },
    getLastPhoto(opening) {
      // eslint-disable-next-line
      if (opening.photos !== null && opening.photos.length > 0) {
        let photo = opening.photos[0]
        for (let index = 0; index < opening.photos.length; index++) {
          const element = opening.photos[index]
          if (element.captureTime > photo.captureTime) {
            photo = element
          }
        }
        return photo
      }
    },
    setSelectedPhoto(photo) {
      this.selectedPhoto = photo
    },
    setSelectedPenetrant(penetrant) {
      const index = this.openingData.penetrants.findIndex(e => e.penetrantId === penetrant.penetrantId)
      this.selectedPenetrant = index
    },

    async deletePhoto(photo) {
      const res = await this.deleteAlert(`foto van ${this.$options.filters.prettyDate(photo.captureTime)}`)
      if (res == 'deleted') {
        this.removedPhotos.push(photo.photoId)
        this.openingData.photos = this.openingData.photos.filter(e => e.photoId != photo.photoId)
      }
    },
    async deletePenetrant(penetrant) {
      const res = await this.deleteAlert(`doorvoering met type ${penetrant.type}`)
      if (res == 'deleted') {
        this.$nextTick(() => (this.selectedPenetrant = -1))
        this.removedPenetrants.push(penetrant.penetrantId)
        const index = this.openingData.penetrants.findIndex(e => e == penetrant)
        console.log(index)
        if (index >= 0) {
          this.openingData.penetrants.splice(index, 1)
        }
      }
    },
    addPenetrant(val) {
      const newPenetrant = new Object()
      newPenetrant.mainType = val
      newPenetrant.type = ''
      newPenetrant.isolation = ''
      newPenetrant.system = ''
      newPenetrant.sizeCategory = ''
      newPenetrant.length = 0
      newPenetrant.count = 1
      newPenetrant.complexityFactor = 1
      newPenetrant.openingId = this.openingData.openingId
      this.openingData.penetrants.push(newPenetrant)
      this.selectedPenetrant = this.openingData.penetrants.length - 1
      this.newPenetrants.push(newPenetrant)
      this.listChoise = 'Klik hier om een nieuwe opening toe te voegen'
    },
    compare() {
      return (
        this.openingData.assemblyTime !== this.selectedOpening.assemblyTime ||
        this.openingData.captureTime !== this.selectedOpening.captureTime ||
        this.openingData.comment !== this.selectedOpening.comment ||
        this.openingData.dbDate !== this.selectedOpening.dbDate ||
        this.openingData.dbUser !== this.selectedOpening.dbUser ||
        this.openingData.fireRating !== this.selectedOpening.fireRating ||
        this.openingData.idOnDrawing !== this.selectedOpening.idOnDrawing ||
        this.openingData.room !== this.selectedOpening.room ||
        this.openingData.tagId !== this.selectedOpening.tagId ||
        this.openingData.wallFloorAssembly !== this.selectedOpening.wallFloorAssembly
      )
    },
    comparePenetrant(origP, newP) {
      return (
        newP.complexityFactor !== origP.complexityFactor ||
        newP.count !== origP.count ||
        newP.isolation !== origP.isolation ||
        newP.length !== origP.length ||
        newP.openingId !== origP.openingId ||
        newP.sizeCategory !== origP.sizeCategory ||
        newP.system !== origP.system ||
        newP.type !== origP.type
      )
    }
  }
}
</script>

<style lang="scss">
.force-right {
  justify-content: flex-end;
}
.custom-upload {
  padding-top: 30px;
  .section {
    padding: 5rem 1.5rem;
  }
}
.miniButton {
  margin-top: 1px;
  padding-left: 3px;
  padding-right: 3px;
  height: 18px;
  align-items: center;
  box-align: center;
  -webkit-box-align: center;
  .icon {
    margin-top: -4px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects/OpeningModal.vue